"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCredit = exports.PRECISION = void 0;
const agricultureCal_1 = require("./calculators/agricultureCal");
const soilEnrichmentCal_1 = require("./calculators/soilEnrichmentCal");
const solarCal_1 = require("./calculators/solarCal");
const agricultureCreationRequest_1 = require("./requests/agricultureCreationRequest");
const soilEnrichmentCreationRequest_1 = require("./requests/soilEnrichmentCreationRequest");
const stovesHousesNamibiaCreationRequest_1 = require("./requests/stovesHousesNamibiaCreationRequest");
const solarCreationRequest_1 = require("./requests/solarCreationRequest");
const stovesHousesNamibiaCal_1 = require("./calculators/stovesHousesNamibiaCal");
const solarWaterPumpingOffGridCreationRequest_1 = require("./requests/solarWaterPumpingOffGridCreationRequest");
const solarWaterPumpingOffGridCal_1 = require("./calculators/solarWaterPumpingOffGridCal");
const solarWaterPumpingOnGridCreationRequest_1 = require("./requests/solarWaterPumpingOnGridCreationRequest");
const solarWaterPumpingOnGridCal_1 = require("./calculators/solarWaterPumpingOnGridCal");
exports.PRECISION = 2;
const calculateCredit = (request) => {
    if (request instanceof agricultureCreationRequest_1.AgricultureCreationRequest) {
        return agricultureCal_1.AgricultureCal.calculate(request);
    }
    else if (request instanceof solarCreationRequest_1.SolarCreationRequest) {
        return solarCal_1.SolarCal.calculate(request);
    }
    else if (request instanceof soilEnrichmentCreationRequest_1.SoilEnrichmentCreationRequest) {
        return soilEnrichmentCal_1.SoilEnrichmentCal.calculate(request);
    }
    else if (request instanceof stovesHousesNamibiaCreationRequest_1.StovesHousesNamibiaCreationRequest) {
        return stovesHousesNamibiaCal_1.StovesHousesNamibiaCal.calculate(request);
    }
    else if (request instanceof solarWaterPumpingOffGridCreationRequest_1.SolarWaterPumpingOffGridCreationRequest) {
        return solarWaterPumpingOffGridCal_1.solarWaterPumpingOffGridCal.calculate(request);
    }
    else if (request instanceof solarWaterPumpingOnGridCreationRequest_1.SolarWaterPumpingOnGridCreationRequest) {
        return solarWaterPumpingOnGridCal_1.solarWaterPumpingOnGridCal.calculate(request);
    }
    else {
        throw Error("Not implemented");
    }
};
exports.calculateCredit = calculateCredit;
